"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentRequestType = void 0;
var PaymentRequestType;
(function (PaymentRequestType) {
    PaymentRequestType[PaymentRequestType["OrderCancelationFee"] = 0] = "OrderCancelationFee";
    PaymentRequestType[PaymentRequestType["TravelVoucher"] = 1] = "TravelVoucher";
})(PaymentRequestType || (exports.PaymentRequestType = PaymentRequestType = {}));
//# sourceMappingURL=PaymentRequestType.js.map